export const work = {
  Favorite: 'Favorito',
  Unfavorite: 'Quitar de favoritos',
};
